import { HelpCircle } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "¿Cuánto tarda el servicio a domicilio?",
    a: "Entregamos tu ropa limpia, seca y planchada en 24-48 horas desde la recogida. Reservas online en 2 minutos, recogemos en tu puerta en la fecha que elijas y te avisamos por email en cada paso.",
  },
  {
    q: "¿Cuánto tarda un lavado en el autoservicio?",
    a: "Un lavado completo tarda entre 30 y 40 minutos, y el secado entre 20 y 30 minutos. Mientras esperas puedes disfrutar de nuestra zona de café y snacks. Abrimos todos los días de 7:30 a 22:30.",
  },
  {
    q: "¿Cuánta ropa cabe en cada máquina?",
    a: "En el local tenemos lavadoras de 12 kg y de 20 kg (ideal para edredones y colchas) y secadoras de 19 kg. Como referencia, en 12 kg cabe la colada semanal de una familia de 3-4 personas. En el servicio a domicilio, cada carga admite hasta 8 kg.",
  },
  {
    q: "¿Cómo puedo pagar?",
    a: "Online aceptamos todas las tarjetas (Visa, Mastercard, American Express...) con pago 100% seguro. En el local puedes pagar en efectivo, con tarjeta bancaria o con la Tarjeta VIP Cliente, que te da precios reducidos en cada lavado.",
  },
  {
    q: "¿Qué es la Tarjeta VIP Cliente y cómo la consigo?",
    a: "Es nuestra tarjeta recargable con la que ahorras hasta un 20% en cada uso: lavadora de 12 kg por 4 € (en vez de 5 €), de 20 kg por 7,50 € (en vez de 9 €) y secadora por 2,50 € (en vez de 3 €). Se compra y se recarga directamente en el kiosco del local, en las opciones «Comprar Tarjeta» y «Cargar Saldo».",
  },
  {
    q: "¿Laváis edredones, sábanas y ropa de cama?",
    a: "¡Sí! Es una de nuestras especialidades. A domicilio, el juego de ropa de cama cuesta 20 €. En el local, la lavadora de 20 kg es perfecta para edredones nórdicos y colchas grandes.",
  },
  {
    q: "¿Cómo funciona la recogida a domicilio?",
    a: "Al reservar, eliges la fecha y nos indicas tu dirección. Pasamos a recoger tu ropa, la lavamos, secamos y planchamos según lo que hayas elegido, y te la devolvemos en 24-48 horas. El servicio de recogida y entrega cuesta solo 5 €.",
  },
  {
    q: "¿Puedo saber en qué estado está mi pedido?",
    a: "Sí. Con el número de pedido que recibes por email puedes consultar el estado en la sección «Seguimiento» de esta web. Además, te enviamos un email automático cuando tu ropa está lista y cuando ha sido entregada.",
  },
];

export const FAQ = () => (
  <section id="faq" className="py-16 sm:py-24 bg-slate-50">
    <div className="max-w-4xl mx-auto px-4 sm:px-6">
      <div className="text-center mb-8 sm:mb-12">
        <span className="inline-flex items-center justify-center h-14 w-14 rounded-2xl bg-cyan-50 text-cyan-600 mb-4">
          <HelpCircle className="h-7 w-7" />
        </span>
        <h2 className="text-3xl sm:text-4xl font-heading font-bold text-slate-900">Preguntas Frecuentes</h2>
        <p className="mt-3 text-slate-600">Resolvemos las dudas más habituales sobre tiempos, pesos y pagos.</p>
      </div>
      <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem key={f.q} value={`faq-${i}`} data-testid={`faq-item-${i}`}
            className="bg-white border border-slate-200 rounded-xl px-4 sm:px-6 [&[data-state=open]]:border-cyan-300">
            <AccordionTrigger className="font-heading font-semibold text-left text-slate-900 hover:text-cyan-600 hover:no-underline text-sm sm:text-base py-4">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-slate-600 text-sm leading-relaxed">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
